export default __webpack_public_path__ + "static/media/go_back_arrow.cce0bd2a.svg";